/**
 * @generated SignedSource<<52221207e921c6ab425a2ee6dee40278>>
 * @relayHash 6ba4246d568f662506bcf5f862b52c70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery$variables = {
  pageId: ReadonlyArray<string>;
  startTime: string;
};
export type useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery$data = {
  readonly countGroupByPage: {
    readonly nodes: ReadonlyArray<{
      readonly count: number;
      readonly page: string;
    }>;
  } | null | undefined;
};
export type useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery = {
  response: useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery$data;
  variables: useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startTime"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "eventName",
        "value": [
          "reaction_created"
        ]
      },
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      },
      {
        "kind": "Variable",
        "name": "startTime",
        "variableName": "startTime"
      }
    ],
    "concreteType": "CountGroupByPage",
    "kind": "LinkedField",
    "name": "countGroupByPage",
    "plural": false,
    "selections": [
      {
        "concreteType": "CountGroupByPageItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          },
          {
            "kind": "ScalarField",
            "name": "page"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6ba4246d568f662506bcf5f862b52c70",
    "id": "307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303",
    "metadata": {},
    "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
    "operationKind": "query",
    "text": "query useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery($pageId:[ID!]!,$startTime:String!){countGroupByPage(pageId:$pageId,startTime:$startTime,eventName:[reaction_created],limit:1){nodes{count,page}}}"
  }
};
})();

(node as any).hash = "e0f215e969dd8fe8e354bb8df118ce2f";

export default node;
